import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";

let cancelToken;

const costCenterReportModURL = "api/v1/cost-center/cost-center-details/transactions";

//obtaining the paginated data
export const getCostCenterReport = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${costCenterReportModURL}?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllCostCenterReport = () => axiosInstance.get(`${costCenterReportModURL}?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageCostCenterReport = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${costCenterReportModURL}?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createCostCenterReport = (body) => axiosInstance.post(`${costCenterReportModURL}/create`, body);
//updating function
export const updateCostCenterReport = (id, body) => axiosInstance.patch(`${costCenterReportModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${costCenterReportModURL}/list?offset=0&limit=${rowsPerPage} &ordering=${sortOrder} &search=${search}`);

// checking the redundant data
export const checkRedundantDataCostCenterReportName = (e, cancelToken) =>
  axiosInstance.get(`${costCenterReportModURL}?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
